<template>
    <CustomHeader :text="$t('activityName.user_rank')" :is-popup-close-back-icon="true" bgColor="#154084"
        @close-popup="navToBack" />
    <div class="level_container">
        <div class="top_card">
            <img src="@/assets/themeThree/banner01.png" alt="">
            <div class="top_content">
                <img :src="dataSet.currentRankIcon ? dataSet.currentRankIcon : require('@/assets/themeThree/v0.png')" alt="">
                <div class="text_2">
                    {{ dataSet.currentRankName ? dataSet.currentRankName : $t('rewards.notActivated') }}
                </div>
                <div>
                </div>
            </div>
        </div>
        <div class="level_scroll_wrapper">
            <div class="level_list">
                <div v-for="(item, index) in dataSet.levelList" :key="item.rank"
                    style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                    <div class="level_item" :class="dataSet.activeRank >= item.rank ? 'active_level' : ''">
                        <img :src="item.icon2" alt="">
                    </div>
                    <div style="color: #737BB2; padding: 15px 0; font-size: 14px;">
                        {{ item.rank_name }}
                    </div>
                    <div class="manual_level_bar" v-if="dataSet.levelList.length > 0">
                        <div class="step_line left" :class="{ active: dataSet.activeRank > dataSet.levelList[0].rank }">
                        </div>
                        <div class="level_step" :class="{ active: dataSet.activeRank >= item.rank }">
                            <div class="step_dot2">
                                <div class="step_dot"></div>
                            </div>
                            <div class="step_label">{{ Number(item.turnover_amount) }}</div>
                            <div v-if="index !== dataSet.levelList.length - 1" class="step_line"
                                :class="{ active: dataSet.activeRank >= dataSet.levelList[index + 1].rank }"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle_container">
            <img src="@/assets/themeThree/crown.png" alt="">
            <div>
                {{ $t('level.title') }}
            </div>
        </div>
        <div class="label_container">
            <div v-for="(item, index) in dataSet.rewardsList" :key="index" class="label_text">
                <van-row >
                    <van-col span="3" class="checkingDoneTick">
                        <img src="@/assets/themeThree/coin.png" alt="" width="40%">
                        <div class="checked">
                            <img v-if="item.status == 2" src="@/assets/bonus/select.png" width="12px" alt="">
                        </div>
                    </van-col>
                    <van-col span="5" class="day_text">{{ $t('common.travel') }} {{ item.day }}</van-col>
                    <van-col span="4" class="currency_text">R$ <span>{{ formatCurrency(Number(item.reward))
                            }}</span></van-col>
                    <van-col span="10" offset="2" class="label_img">
                        <div v-if="item.status == 2" class="select_icon"> <img src="@/assets/bonus/select.png" alt="">
                        </div>
                        <div v-if="item.status == 1" class="activeText" @click="clickOnCard"
                            :class="{ 'pop-animate': isPopping }">
                            <van-loading v-if="isLoading" size="15" type="spinner" />
                            <div v-else>{{ $t('common.notCompleted') }}</div>
                        </div>
                        <div v-if="item.status == 0" class="activeText" style=" color: #7a7a7a66; font-weight: 500;">{{
                            $t('common.notCompleted') }}</div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="bottom_text">
            <div class="title">{{ $t('common.activityTitle') }}</div>
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { LevelViewData } from '@/view/level/supportScript';
import { ref } from 'vue'
import { useRouter } from 'vue-router';

const isPopping = ref(false)
const isLoading = ref(false)
const router = useRouter()
const emits = defineEmits(['userRankDailyCheckin'])
const props = defineProps<{
    dataSet: LevelViewData
}>()

const userRankDailyCheckin = () => {
    emits('userRankDailyCheckin')
}

const clickOnCard = () => {
    isPopping.value = true
    userRankDailyCheckin()
    setTimeout(() => {
        isPopping.value = false
    }, 300)
}

const isLoadingTrue = () => {
    isLoading.value = true
}
const isLoadingFalse = () => {
    isLoading.value = false
}
const navToBack = () => {
    router.go(-1)
}
defineExpose({
    isLoadingTrue,
    isLoadingFalse
})

</script>
<style scoped>
.level_container {
    padding: 70px 0;
    --cell-min-width: 65px;
    background-color: #090F1F !important;
    font-family: serif;
}

.top_card {
    position: relative;
}

.top_card img {
    width: 100%;

}

.top_content {
    position: absolute;
    bottom: 15px;
    right: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    align-items: center;
}

.top_content img {
    width: 45%;

}

.text_1 {
    color: #fff;
    font-size: 15px;
    opacity: 0.8;
}

.level_text {
    position: absolute;
    bottom: 17px;
    left: 20px;
}

.text_2 {
    color: #fff;
    font-size: 23px;
    font-weight: 700;
    margin-top: 10%;
}

.level_name {
    position: absolute;
    bottom: 35px;
    left: 20px;
    right: 20px;
}

.value_text {
    position: absolute;
    width: 200px;
    top: 90px;
    left: 20px;
}

.value {
    position: absolute;
    top: 130px;
    left: 20px;
}

.level_scroll_wrapper {
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 0 5%;
    padding-bottom: 6px;
}

.level_scroll_wrapper::-webkit-scrollbar {
    display: none;
}


.level_list {
    display: flex;
    align-items: center;
    min-width: max-content;
    padding: 25px 0 8px;
    flex-direction: row;
    text-align: center;
    color: rgba(255, 255, 255, 0.45);
    overflow-x: auto;
    white-space: nowrap;
    gap: 8.55px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.level_list::-webkit-scrollbar {
    display: none;
}

.level_cell {
    flex: 0 0 var(--level-cell-width);
    min-width: var(--cell-min-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.level_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0);
    border-radius: 10px;
    padding: 6px 6px;
    box-sizing: border-box;
}

.level_item img {
    height: auto;
    display: block;
    width: 55px;
}

.manual_level_bar {
    display: flex;
    align-items: center;
    min-width: max-content;
    gap: 0;
    padding: 6px 0 0;
}

.manual_level_bar {
    display: flex;
    align-items: center;
    min-width: max-content;
    gap: 0;
    padding: 6px 0 0;
}

.level_step {
    flex: 0 0 var(--level-cell-width);
    min-width: var(--cell-min-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
}

.connector {
    position: absolute;
    top: 6px;
    left: 50%;
    width: calc(var(--level-cell-width));
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 1;
}

.connector.active {
    background-color: #F9C486;
}

.step_dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    z-index: 2;
}

.step_dot2 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 3px solid #122c479e;
    background: #090F1F;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.level_step.active .step_dot2 {
    background-color: rgb(255, 255, 255);
    margin-left: -10px;
}

.step_label {
    z-index: 3;
    text-align: center;
    font-size: 14px;
    margin-top: 4px;
    color: #6b708685;
}

.level_step.active .step_label {
    color: #737BB2;
}

.step_line {
    position: absolute;
    top: 6px;
    left: 50%;
    width: 100%;
    height: 2px;
    background-color: #122c479e;
    z-index: 1;
}

.step_line.active {
    background-color: #737BB2;
}

.middle_container {
    padding: 20px;
    background-color: #202940;
    border-radius: 10px 10px 0 0;
    color: #9BA7BE;
    margin: 15px 15px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
}

.middle_container img {
    width: 10%;
    padding-right: 10px;
}

.label_container {
    padding: 0 15px;
}

.label_container img {
    width: 100%;
}

.label_text {
    background-color: #101629; 
}

.label_text:nth-child(even) {
    background-color: #151C2F;
}

.checkingDoneTick {
    display: flex;
    justify-content: right;
    align-items: center;
    position: relative;
}

.checkingDoneTick img {
    width: 60%;
}

.checked img {
    width: 12px;
    position: absolute;
    right: 0;
}

.day_text {
    font-size: 18px;
    color: #9BA7BE;
    font-weight: 500;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.currency_text {
    font-size: 16px;
    color: #2F3852;
    padding-left: 10px;
    display: flex;
    align-items: center;
    font-weight: bold;
}

.currency_text span {
    color: #FBA531;
    font-size: 18px;
    padding-left: 5px;
}

.label_img {
    display: flex;
    justify-content: center;
}

.label_img img {
    width: 140px;
}

.activeText {
    font-size: 18px;
    color: #737BB2;
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding: 20px;
}

.step_line.left {
    position: absolute;
    top: 6px;
    left: 15px;
    width: calc(50% / 6);
    height: 0.5px;
    background-color: #F9C486;
    z-index: 1;
}

.active_level {
    background: linear-gradient(0deg, #0167CA -13.77%, #38A8FA 102.34%);
    border: 1px solid #4b38477d !important;
}

.bottom_text {
    padding: 25px;
}

.title {
    color: #ffffffa3;
    font-weight: bold;
    font-size: 20px;
    padding: 10px 0;
    font-family: sans-serif;
}

.line_text {
    color: #ffffff65;
    font-size: 15px;
    padding: 5px;
    font-family: sans-serif;
    line-height: 20px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@media (min-width: 400px) {
    .level_item {
        width: 100%;
    }

}

@media (max-width: 360px) {
    .middle_container {
        font-size: 16px;
    }

    .day_text {
        font-size: 15px;
    }

    .activeText {
        font-size: 16px;
    }
}
</style>